/**************************************************
 * Nombre:       Formulario_Cuentas_Documentos_Requeridos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {ArticleOutlined, CloudDownload, Flag, VisibilityOff, VisibilityOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {TIPODOCSREQ} from "../../../Constantes";
import IngresoImagen from "../../../Modulo_formularios/Componentes/IngresoImagen";
import {irUrl} from "../../../Utilidades/irUrl";
import IngresoPdf from "../../../Modulo_formularios/Componentes/IngresoPdf";

const Formulario_Cuentas_Documentos_Requeridos = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                {props.props.getValues('tipo') && props.props.getValues('tipo') === 'Pdf' ?


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <IngresoPdf dato={'recurso'} {...props} />
                    </Grid>

                    :

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <IngresoImagen dato={'recurso'} {...props} />
                    </Grid>




                }




                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Tipo'} dato={'tipo'} {...props}
                                   requerido={'El tipo es requerido'}
                                   opciones={TIPODOCSREQ} editable={false}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => irUrl(props.props.getValues('recurso'))}
                        startIcon={<VisibilityOutlined/>}>Ver</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={ArticleOutlined} nombre={'Nombre del documento'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Cuentas_Documentos_Requeridos